import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Participant {
    id: string;
    name: string;
    groupId?: string;
    photo?: string;
    idCardNumber?: string;
    class?: string;
    year?: string;
    age?: number;
    chestNumber?: string;
    group?: { name: string; color: string };
    events?: { id: string; name: string; code: string }[];
}

interface ParticipantState {
    participants: Participant[];
    loading: boolean;
    error: string | null;
}

const initialState: ParticipantState = {
    participants: [],
    loading: false,
    error: null,
};

const participantSlice = createSlice({
    name: 'Participant',
    initialState,
    reducers: {
        setParticipants: (state, action: PayloadAction<Participant[]>) => {
            state.participants = action.payload;
            state.loading = false;
            state.error = null;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
            state.loading = false;
        },
        addParticipant: (state, action: PayloadAction<Participant>) => {
            state.participants.unshift(action.payload);
        },
        updateParticipantInList: (state, action: PayloadAction<Participant>) => {
            const index = state.participants.findIndex((p) => p.id === action.payload.id);
            if (index !== -1) {
                state.participants[index] = action.payload;
            }
        },
        removeParticipantFromList: (state, action: PayloadAction<string>) => {
            state.participants = state.participants.filter((p) => p.id !== action.payload);
        },
    },
});

export const {
    setParticipants,
    setLoading,
    setError,
    addParticipant,
    updateParticipantInList,
    removeParticipantFromList,
} = participantSlice.actions;
export default participantSlice.reducer;
